import { User } from "../../../../../interfaces/User";

export function createMailWithSubscribed(dataTableUsers: [], edition: any) {
  let baseURL = "https://outlook.office.com/mail/deeplink/compose?to=";

  let userEmails = dataTableUsers.map((user: User) => user.email);

  const facultyEmails = edition.sessions.flatMap((session: any) =>
    (session.faculties || []).map((f: any) => f.email),
  );

  const tutorEmails = edition.sessions.flatMap((session: any) =>
    (session.tutors || []).map((t: any) => t.email),
  );

  const allEmails = Array.from(
    new Set([...userEmails, ...facultyEmails, ...tutorEmails].filter(Boolean)),
  ).join(",");

  const subject =
    edition.learning_objects?.label +
    " [Edizione " +
    (edition.edition_code ? edition.edition_code : edition.id) +
    "]";

  return baseURL + allEmails + "&subject=" + encodeURIComponent(subject);
}
